export default (palette, typography) => ({
  fontFamily: typography.fontFamily,
  fontColor: palette.grey.G600,
  selectedBorderColor: palette.grey.G300,
  selectedBackgroundColor: palette.grey.G200,
  disabledTextColor: palette.text.dark,
  disabledBackgroundColor: palette.grey.G200,
  disabledBorderColor: palette.grey.G400,
  outlineReplacement: `inset 0 0 3px 2px ${palette.outline}`,
  weeklyButtons: {
    borderRadius: 0,
    backgroundColor: 'transparent',
    borderColor: palette.grey.G400,
    color: palette.grey.G600,
    '&:first-child': {
      borderRadius: [30, 0, 0, 30]
    },
    '&:last-child': {
      borderRadius: [0, 30, 30, 0]
    },
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&:focus': {
      backgroundColor: palette.grey.G400,
      boxShadow: `inset 0 0 3px 2px ${palette.outline}`
    }
  },
  weeklyActiveButtons: {
    borderColor: palette.grey.G300,
    backgroundColor: palette.grey.G200,
    borderLeft: 'none',
    marginLeft: 1,
    '&:hover, &:focus': {
      backgroundColor: palette.grey.G200
    }
  },
  addBtnIcon: {
    display: 'none'
  }
});
